import type { FaireProductEntity } from "../../entity_types/product";

export const p_9w2rmsyhnx: FaireProductEntity = {
  token: "p_9w2rmsyhnx",
  type: "product",
  name: "NATURAL AGATE GLASS SEMI PRECIOUS BEAD NECKLACE | 80N896",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/2e37879527191fe2892ac74da47db5f48cad17e3c347708866c75076965be712.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c4512ca53d3151762a4fba9213d394697800ca763c1af2427df234da041da03.jpeg",
    "https://cdn.faire.com/fastly/57cb1b335ef045afe1d22dae2a139d42ca61533d2ae0c102d271040a023e87fa.jpeg",
    "https://cdn.faire.com/fastly/f2f3608c66cfa59b2ec626e1ced586ffb4bf37c41d2ae3fd12e56376a6e8b5f0.jpeg",
    "https://cdn.faire.com/fastly/ee076e289700e2d57b9b8c774a8caf0802463e7f682e3a149ce104125b15405b.jpeg",
    "https://cdn.faire.com/fastly/0d872c5b5ef1abed208241d69473eaa6d87696494fd37dc29f15c00e71d74809.jpeg",
    "https://cdn.faire.com/fastly/fe30f74cd537fa9fbc42c2688eb815f8e4bdea33fb027a71184cb464fe9c101c.jpeg",
    "https://cdn.faire.com/fastly/d213cf43c245ff862366db9fcbc5bbc2153ef1dc05ecdf53035c02d9189e34f2.jpeg",
    "https://cdn.faire.com/fastly/fdfa8156f329ef931b13df7fd43f0658d6f125b77760ad48cbf6433f9cfa9faf.jpeg",
    "https://cdn.faire.com/fastly/131c6afaa37fe2fa0b69d6977deaaf4569a6b08624c832b1c2dce15d3e690476.jpeg",
    "https://cdn.faire.com/fastly/8dc45e13524b25d1d4f4a2a459247763574809223d9c39f257463272f7512c18.jpeg",
    "https://cdn.faire.com/fastly/6dc5dea9da154251c4d8fe778b8b1a9aad81d032923bff41852364297d1db4e9.jpeg",
    "https://cdn.faire.com/fastly/4c841f6aa4700caa7d96c65947f6b54a91cba1765420359cc29d74be0f12c237.jpeg",
    "https://cdn.faire.com/fastly/807b1045c3896cd1b457ce7b5ef353a85e59cc02d10597d4be42aa304ff48232.jpeg",
    "https://cdn.faire.com/fastly/543d5d5551fba3b8a955bc20d2e98071c5537a715d089be4e576be7048564293.jpeg",
  ],
  priceDollars: 9.25,
  description:
    'Natural Agate Glass Semi-Precious Bead Necklace, a stunning accessory that features a vibrant mix of glass and semi-precious beads. A stunning piece that combines elegance with vibrant charm. This necklace features a mix of hand-picked glass and semi-precious beads, including beautiful natural agate, arranged to create a captivating and colorful motif.\n\nProduct Details:\nlength:  16"\next:  3" Ball Chain Ext\nclasp: Lobster Claw\nmetal finish:  Gold Plated\nproduct: Lead & Nickel Compliant\nanti-tarnish: Double E-coating\n\nNatural Agate Necklace |  Glass Neckalce |  Glass Bead necklace |  semi precioius stone necklace |  beaded necklace |\nAgate Necklace | New Color Necklace | Classic necklace |  natural necklace |  handmade |  colorful \n\n\n\n',
  tags: [],
  msrpDollars: 18.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:51.730Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
